/* eslint import/no-import-module-exports: 0 */
import { inspect } from '@xstate/inspect';
import * as React from 'react';
import { render } from 'react-dom';

import { App } from 'App';
import { initSentry } from 'sentry';

if (CONFIG.isDevelopment) {
  inspect({
    iframe: false, // open in new window
    url: 'https://stately.ai/viz?inspect',
    serialize: (key: string, value: unknown) => {
      if (key.match(/Ref$/g)) {
        console.warn(`xstate inspector dom node "${key}"`, value);
        return `<<omitted dom node>>`;
      }
      return value;
    }
  });
}

initSentry();

render(<App />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept();
}
/* eslint import/no-import-module-exports: 1 */
